import routeNames from '@routes/routeNames';
import messages from './messages';
import { permission } from '../../../containers/admin/Secure/permission';

const BASE_CUSTOMERS_TERTIARY_NAVIGATION = {
  routeMatches: ['Customers'],
  breadcrumbs: [],
  routes: []
};

const BASE_CUSTOMER_TERTIARY_NAVIGATION = {
  routeMatches: [
    'CustomerOverview',
    'CustomerPaymentIds',
    'CustomerTrackingCodes',
    'CustomerMembers',
    'CustomerRates',
    'CustomerPreferences',
    'CustomerFeatureSettings'
  ],
  breadcrumbs: [
    { label: 'All Customers', route: 'Customers', param: '' },
    { label: '', route: 'CustomerOverview', param: 'customerId' }
  ],
  routes: [
    {
      route: 'CustomerTrackingCodes',
      label: messages.linkTrackingCodes,
      icon: '',
      analyticID: 'CustomerTrackingCodes'
    },
    {
      route: 'CustomerPaymentIds',
      label: messages.linkCustomerPaymentIds,
      icon: '',
      analyticID: 'customerMembers',
      reqPermission: permission.view.customerManagement
    },
    {
      route: 'CustomerMembers',
      label: messages.linkCustomerMembers,
      icon: '',
      analyticID: 'customerMembers',
      reqPermission: permission.view.customerManagement
    },
    {
      route: '',
      label: messages.linkCustomersSettings,
      icon: 'settings',
      subMenu: [
        {
          route: 'CustomerRates',
          label: messages.linkCustomerRates
        },
        {
          route: 'CustomerPreferences',
          label: messages.linkCustomerPreferences,
          reqPermission: permission.view.customerPreferencesView
        },
        {
          route: 'CustomerFeatureSettings',
          label: messages.linkCustomerFeatures
        }
      ],
      analyticID: 'customerSettings',
      reqPermission: permission.view.customerManagement
    }
  ]
};

const CUSTOMER_MEMBER_TERTIARY_NAVIGATION = {
  routeMatches: ['MemberDetails'],
  breadcrumbs: [
    { label: 'All Customers', route: 'Customers', param: '' },
    { label: '', route: 'CustomerOverview', param: 'customerId' },
    { label: 'Members', route: 'CustomerMembers', param: '' },
    { label: '', route: 'MemberDetails', param: 'identityId' }
  ],
  routes: []
};

const BASE_SUPPLIER_TERTIARY_NAVIGATION = {
  routeMatches: ['SupplierOverview', 'SupplierProperties'],
  breadcrumbs: [
    { label: 'All Suppliers', route: 'Suppliers', param: '' },
    { label: '', route: 'SupplierOverview', param: 'supplierId' }
  ],
  routes: [
    {
      route: 'SupplierProperties',
      params: {},
      label: messages.linkSupplierProperties,
      icon: '',
      subMenu: [],
      analyticID: 'supplierProperties',
      reqPermission: permission.view.supplierManagement,
      routeMatches: ['SupplierOverview', 'SupplierProperties'],
      breadcrumbs: [
        { label: 'Suppliers', route: '', params: [] },
        { label: 'All Suppliers', route: 'Suppliers', params: [] },
        { label: '', route: 'SuppliersOverview', paramKey: 'supplierId' }
      ]
    }
  ]
};

const SUPPLIER_PROPERTY_TERTIARY_NAVIGATION = {
  routeMatches: [
    routeNames.SUPPLIER_PROPERTY_OVERVIEW,
    routeNames.SUPPLIER_PROPERTY_ROOMS,
    routeNames.SUPPLIER_PROPERTY_CONNECTION,
    routeNames.SUPPLIER_PROPERTY_RATE_MARKUP_LOGS
  ],
  breadcrumbs: [
    { label: 'All Suppliers', route: 'Suppliers', param: '' },
    { label: '', route: 'SupplierOverview', param: 'supplierId' },
    { label: 'Properties', route: 'SupplierProperties', param: '' },
    { label: '', route: routeNames.SUPPLIER_PROPERTY_OVERVIEW, param: 'propertyId' }
  ],
  routes: [
    {
      route: routeNames.SUPPLIER_PROPERTY_ADD_ROOMS,
      label: messages.linkSupplierPropertyAddRooms,
      reqPermission: permission.view.addRooms
    },
    {
      route: '',
      label: messages.linkSupplierPropertySettings,
      icon: 'settings',
      subMenu: [
        {
          route: routeNames.SUPPLIER_PROPERTY_CONNECTION,
          label: messages.linkSupplierPropertyConnection
        },
        {
          route: routeNames.SUPPLIER_PROPERTY_RATE_MARKUP_LOGS,
          label: messages.linkSupplierPropertyRateMarkupLogs
        }
      ],
      analyticID: 'supplierPropertySettings',
      reqPermission: permission.view.property
    }
  ]
};

const BASE_BOOKINGS_TERTIARY_NAVIGATION = {
  routeMatches: ['Bookings']
};

const BASE_BOOKING_TERTIARY_NAVIGATION = {
  routeMatches: [
    'BookingOverview',
    'BookingRoomNights',
    'BookingFolios',
    'BookingPaymentRecords',
    'BookingVirtualCreditCard',
    'BookingTickets',
    'BookingRateCards'
  ],
  breadcrumbs: [
    { label: 'All Bookings', route: 'Bookings', param: '' },
    { label: '', route: 'BookingOverview', param: 'bookingId' }
  ],
  routes: [
    {
      route: 'BookingRoomNights',
      label: messages.linkBookingRoomNights,
      icon: '',
      analyticID: 'bookingRoomNights',
      reqPermission: permission.view.bookingManagement,
      routeMatches: ['BookingRoomNights']
    },
    {
      route: 'BookingFolios',
      label: messages.linkBookingFolios,
      icon: '',
      analyticID: 'bookingFolios',
      reqPermission: permission.view.bookingManagement,
      routeMatches: ['BookingFolios']
    },
    {
      route: 'BookingPaymentRecords',
      label: messages.linkBookingPaymentRecords,
      icon: '',
      analyticID: 'bookingPaymentRecords',
      reqPermission: permission.view.bookingManagement,
      routeMatches: ['BookingPaymentRecords']
    },
    {
      route: 'BookingVirtualCreditCard',
      label: messages.linkBookingVirtualCreditCard,
      icon: '',
      analyticID: 'BookingVirtualCreditCard',
      reqPermission: permission.view.bookingManagement,
      routeMatches: ['BookingVirtualCreditCard']
    },
    {
      route: 'BookingTickets',
      label: messages.linkBookingTickets,
      icon: '',
      analyticID: 'BookingTickets',
      reqPermission: permission.view.bookingManagement,
      routeMatches: ['BookingTickets']
    },
    {
      route: 'BookingRateCards',
      label: messages.linkBookingRateCards,
      icon: '',
      analyticID: 'bookingRateCards',
      reqPermission: permission.view.bookingManagement,
      routeMatches: ['BookingRateCards']
    }
  ]
};

const CREATE_BOOKING_TERTIARY_NAVIGATION = {
  routeMatches: ['BookingCreate'],
  breadcrumbs: [
    { label: 'All Bookings', route: 'Bookings', param: '' },
    { label: 'Create New Booking', route: 'BookingCreate', param: '' }
  ]
};

const CREATE_BOOKING_ROOM_ASSGN_TERTIARY_NAVIGATION = {
  routeMatches: ['BookingCreateRoomAssignment'],
  breadcrumbs: [
    { label: 'All Bookings', route: 'Bookings', param: '' },
    { label: 'Create New Booking', route: 'BookingCreate', param: '' },
    { label: 'Room Assignment', route: 'BookingCreateRoomAssignment', param: '' }
  ]
};
const SUPPLIER_PROPERTY_ADD_ROOMS = {
  routeMatches: ['SupplierPropertyAddRooms'],
  breadcrumbs: [
    { label: 'All Suppliers', route: 'Suppliers', param: '' },
    { label: '', route: 'SupplierOverview', param: 'supplierId' },
    { label: 'Properties', route: 'SupplierProperties', param: '' },
    { label: '', route: 'SupplierPropertyOverview', param: 'propertyId' },
    { label: 'Rooms', route: 'SupplierPropertyAddRooms', param: '' }
  ],
  routes: [
    {
      route: '',
      label: messages.linkSupplierPropertySettings,
      icon: 'settings',
      subMenu: [
        {
          route: routeNames.SUPPLIER_PROPERTY_CONNECTION,
          label: messages.linkSupplierPropertyConnection
        },
        {
          route: routeNames.SUPPLIER_PROPERTY_RATE_MARKUP_LOGS,
          label: messages.linkSupplierPropertyRateMarkupLogs
        }
      ],
      analyticID: 'supplierPropertySettings',
      reqPermission: permission.view.property
    }
  ]
};

const BASE_COGS_TERTIARY_NAVIGATION = {
  routeMatches: ['COGS', 'FoliosByBooking', 'FolioMissing'],
  breadcrumbs: [],
  routes: [
    {
      route: 'COGS',
      label: messages.linkAllFolios,
      icon: '',
      analyticID: 'folios',
      reqPermission: permission.view.folio,
      routeMatches: ['COGS']
    },
    {
      route: 'FoliosByBooking',
      label: messages.linkFoliosByBookings,
      icon: '',
      analyticID: 'foliosByBooking',
      reqPermission: permission.view.folio,
      routeMatches: ['FoliosByBooking']
    },
    {
      route: 'FolioMissing',
      label: messages.linkMissingFolios,
      icon: '',
      analyticID: 'missingFolios',
      reqPermission: permission.view.missingFolios,
      routeMatches: ['FolioMissing']
    }
  ]
};

const RECONCILIATION_TERTIARY_NAVIGATION = {
  routeMatches: ['Viewer'],
  breadcrumbs: [
    { label: 'All Bookings', route: 'Reconciliation', param: '' },
    { label: 'Booking', route: 'Reconciliation', param: 'bookingNumber' },
    { label: 'Folios', route: 'Viewer', param: '' }
  ],
  routes: []
};

const COGS_OVERVIEW_TERTIARY_NAVIGATION = {
  routeMatches: ['FolioOverview'],
  breadcrumbs: [
    { label: 'All Folios', route: 'COGS', param: '' },
    { label: '', route: 'FolioOverview', param: 'folioId' }
  ],
  routes: []
};

const BASE_CHARGESHEETS_TERTIARY_NAV = {
  routeMatches: ['Chargesheets'],
  breadcrumbs: [],
  routes: []
};

const CHARGESHEET_OVERVIEW_TERTIARY_NAV = {
  routeMatches: ['Chargesheet', 'ChargesheetPreview', 'ChargesheetFolios'],
  breadcrumbs: [
    { label: 'All Chargesheets', route: 'Chargesheets', param: '' },
    { label: '', route: 'Chargesheet', param: 'id' }
  ],
  routes: [
    {
      route: 'ChargesheetPreview',
      label: messages.linkChargesheetPreview,
      icon: '',
      analyticID: 'chargesheetPreview',
      reqPermission: permission.view.payment
    },
    {
      route: 'ChargesheetFolios',
      label: messages.linkChargesheetFolios,
      icon: '',
      analyticID: 'chargesheetFolios',
      reqPermission: permission.view.payment
    }
  ]
};

const BASE_TAXES_AND_FEES_TERTIARY_NAVIGATION = {
  routeMatches: ['TaxTemplates', 'TaxesAndFees'],
  breadcrumbs: [],
  routes: [
    {
      route: 'TaxTemplates',
      label: messages.linkTaxTemplates,
      icon: '',
      analyticID: 'taxTemplates',
      reqPermission: permission.view.taxTemplate
    },
    {
      route: 'TaxesAndFees',
      label: messages.linkTaxesFees,
      icon: '',
      analyticID: 'taxesAndFees',
      reqPermission: permission.view.taxTemplate
    }
  ]
};

export const TERTIARY_NAV_LINKS = [
  BASE_CUSTOMERS_TERTIARY_NAVIGATION,
  BASE_CUSTOMER_TERTIARY_NAVIGATION,
  CUSTOMER_MEMBER_TERTIARY_NAVIGATION,
  BASE_SUPPLIER_TERTIARY_NAVIGATION,
  BASE_BOOKINGS_TERTIARY_NAVIGATION,
  BASE_BOOKING_TERTIARY_NAVIGATION,
  CREATE_BOOKING_TERTIARY_NAVIGATION,
  CREATE_BOOKING_ROOM_ASSGN_TERTIARY_NAVIGATION,
  BASE_COGS_TERTIARY_NAVIGATION,
  COGS_OVERVIEW_TERTIARY_NAVIGATION,
  RECONCILIATION_TERTIARY_NAVIGATION,
  BASE_CHARGESHEETS_TERTIARY_NAV,
  CHARGESHEET_OVERVIEW_TERTIARY_NAV,
  BASE_TAXES_AND_FEES_TERTIARY_NAVIGATION,
  SUPPLIER_PROPERTY_TERTIARY_NAVIGATION,
  SUPPLIER_PROPERTY_TERTIARY_NAVIGATION,
  SUPPLIER_PROPERTY_ADD_ROOMS
];
